export default "__VITE_ASSET__BNKvKYru__"